import Image from "next/image";
import Link from "next/link";
import { IMG } from "@/lib/data";
import { Reveal } from "../Reveal";

export function Manifesto() {
  return (
    <section className="px-5 py-24 md:px-8 md:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="font-mono text-[10px] tracking-[0.32em] text-brass uppercase">Le club</p>
            <h2 className="font-display mt-4 text-4xl leading-[0.9] md:text-6xl lg:text-7xl">
              500 licenciés.
              <br />
              Zéro improvisation.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-lg text-lg text-mute">
              Fondé en 1970 par Gilbert Hans et une bande de passionnés, le STO
              est un club de tir de loisir et sportif. Convivialité, discipline,
              règles FFTir. Objectif : 100 % safe & protect.
            </p>
            <p className="mt-4 text-sm text-brass">Saison 25/26 au complet.</p>
            <Link
              href="/le-club"
              className="mt-8 inline-flex text-xs tracking-[0.18em] uppercase underline decoration-brass/40 underline-offset-4"
            >
              L’ADN du STO
            </Link>
          </Reveal>
        </div>
        <Reveal className="hud-frame relative aspect-4/5 overflow-hidden lg:col-span-6" delay={0.12}>
          <Image
            src={IMG.silhouette}
            alt="Silhouette d’un tireur à la ligne de tir"
            fill
            className="object-cover object-[center_30%]"
            sizes="(min-width: 1024px) 50vw, 100vw"
          />
        </Reveal>
      </div>
    </section>
  );
}
